import React, { Component, Fragment, createRef } from 'react';
import { stringify } from 'query-string';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import {UncontrolledTooltip, Modal, ModalBody, Tooltip, FormGroup} from 'reactstrap';
import { array, number, string, bool, func } from 'prop-types';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import CustomControl from '../CustomControl/CustomControl';
import Icon from '../Icon/Icon';
import { FMessage, ThemedFMessage } from '../../hoc/IntlComponents';
import PreviewPopover from '../Preview/PreviewPopover';
import LandingDownloadChooseFlowBlock from '../Offer/LandingDownloadChooseFlowBlock';
import Hint from "@components/Hint/Hint";
import { STATIC_PATH } from '../../config';
import SVG from 'react-inlinesvg';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  name: string.isRequired,
  url: string.isRequired,
  onLandingChange: func.isRequired,
  adaptive: number.isRequired,
  checked: array,
  totalCr: number,
  streamCr: number,
  offerId: number,
  multiple: bool,
  abTest: bool,
  maxCrLandingId: number,
  available: number,
  spForm: number,
};

const defaultProps = {
  checked: [0],
  controls: false,
  multiple: true,
};

const getString = (intl, id, defaultMessage) => intl.formatMessage({ id, defaultMessage });

class FlowLandingsTableItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewPopoverIsOpen: false,
      downloadModalIsOpen: false,
      abTestSelectedTooltipIsOpen: false,
    };
    this.$containerRef = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.closePopoverOnClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.closePopoverOnClickOutside);
  }

  closePopoverOnClickOutside = e => {
    if (this.state.previewPopoverIsOpen && !this.$containerRef.current.contains(e.target)) {
      this.setState(prevState => ({
        ...prevState,
        previewPopoverIsOpen: false,
      }));
    }
  };

  closePop = () => {
      this.setState(prevState => ({
        ...prevState,
        downloadModalIsOpen: false,
      }));
  };

  toggleDownload = () =>
    this.setState(prevState => ({ downloadModalIsOpen: !prevState.downloadModalIsOpen }));

  togglePreviewPopover = () => {
    this.setState(prevState => ({ previewPopoverIsOpen: !prevState.previewPopoverIsOpen }));
  };

  checkMobileString = title => /мобил|mobil/.test(title.toLowerCase());

  getResponsiveTooltip = (isAdaptive, title) => {
    if (isAdaptive) {
      return <FMessage id="tooltip.title.responsive" />;
    } else if (this.checkMobileString(title)) {
      return <FMessage id="tooltip.title.mobile" />;
    }

    return <FMessage id="tooltip.title.non-responsive" />;
  };

  renderDownloadModal = () => {
    const { downloadModalIsOpen } = this.state;
    const { id, offer, streamId, site_key, inFlow, inDomain, name } = this.props;
    return (
      <Modal size="md" isOpen={downloadModalIsOpen} toggle={this.toggleDownload}>
        <ModalBody className="landing-download-modal">
          <LandingDownloadChooseFlowBlock
            offer={offer}
            landingId={id}
            inFlow={inFlow}
            inDomain={inDomain}
            streamId={streamId}
            site_key={site_key}
            name={name}
            closeFn={() => this.closePop()}
          />
        </ModalBody>
      </Modal>
    );
  };

  renderLinkToStatistics = () => {
    const { id, landingsTableType, streamId } = this.props;
    const query = {
      type: landingsTableType,
      [landingsTableType]: id,
    };
    if (streamId) {
      query.flows = streamId;
    }
    return (
      <Link
        className="text-lowercase float-right"
        to={{
          pathname: '/statistics',
          search: `?${stringify(query)}`,
        }}
      >
        <FMessage id="offers.table.geo.title" />
      </Link>
    );
  };

  countCheckedSites = props => {
    const { checked } = props ? props : this.props;
    return checked.length;
  };

  renderABTestTooltip = isChecked => {
    const { id, name, abTest, abTestEnabled, abTestDisabled } = this.props;
    const { abTestSelectedTooltipIsOpen } = this.state;

    // abTestDisabled -> включена прямая ссылка на лендинг
    if (abTestDisabled) return null;

    const sitesCount = this.countCheckedSites();
    if (abTest && !isChecked && sitesCount === 1 && !abTestEnabled) {
      return (
        <UncontrolledTooltip
          placement="right-start"
          target={`label_for_${name}_${id}`}
          delay={{ show: 50, hide: 50 }}
          className="ab-test-tooltip"
        >
          <FMessage id="flow.landings-table.ab-test" />
        </UncontrolledTooltip>
      );
    } else {
      if (abTest && abTestSelectedTooltipIsOpen) {
        return (
          <Tooltip
            placement="right-start"
            target={`label_for_${name}_${id}`}
            isOpen={abTestSelectedTooltipIsOpen}
            className="ab-test-tooltip"
          >
            <ThemedFMessage id="flow.features.ab-test.enabled" />
          </Tooltip>
        );
      } else {
        if (abTest && abTestEnabled) {
          return (
            <UncontrolledTooltip
              placement="right-start"
              target={`label_for_${name}_${id}`}
              delay={{ show: 50, hide: 50 }}
              className="ab-test-tooltip"
            >
              <ThemedFMessage id="flow.features.ab-test.enabled" />
            </UncontrolledTooltip>
          );
        } else {
          return null;
        }
      }
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      id,
      checked,
      abTest,
      abTestEnabled,
    } = this.props;
    if (abTest) {
      const prevChecked = checked.includes(id);
      const nextChecked = nextProps.checked.includes(id);
      if (!abTestEnabled && nextProps.abTestEnabled && !prevChecked && nextChecked) {
        this.setState(
          () => ({ abTestSelectedTooltipIsOpen: true }),
          () => {
            setTimeout(() => {
              this.setState(() => ({ abTestSelectedTooltipIsOpen: false }));
            }, 2000);
          },
        );
      }
    }
  }

  render() {
    const {
      id,
      title,
      totalCr,
      streamCr,
      adaptive,
      name,
      url,
      checked,
      multiple,
      onLandingChange,
      showStreamCr,
      offerId,
      offer,
      toggleIframeConstructorModal,
      intl,
      inFlow,
      theme,
      isTop,
      maxCrLandingId,
      available,
      spForm,
    } = this.props;

    const { previewPopoverIsOpen } = this.state;

    const isChecked = checked.includes(id);

    const isMyOffer = offer && offer.modifies && offer.modifies.is_my;
    const is_cdn = offer && offer.modifies && offer.modifies.is_cdn;

    return (
      <tr className={url.includes('iframe_constructor') ? 'iframe-constructor-row' : ''}>
        <td className="controls">
          {multiple ? (
            <Fragment>
              {/*<CustomControl*/}
              {/*  className="custom-control-xs"*/}
              {/*  id={`${name}_${id}`}*/}
              {/*  name={name}*/}
              {/*  value={id}*/}
              {/*  checked={isChecked}*/}
              {/*  onChange={onLandingChange}*/}
              {/*  disabled={!available}*/}
              {/*/>*/}
              {/*{this.renderABTestTooltip(isChecked)}*/}
              {/* OFFERRUM-2406 */}
              <FormGroup className="sp-enable">
                <CustomControl
                  className="custom-control-xs"
                  id={`${name}_${id}`}
                  name={name}
                  value={id}
                  checked={isChecked}
                  onChange={onLandingChange}
                  disabled={!available}
                />
                {spForm ? (
                  <Hint id={`offer-top-landing-hint-${id}`} placement="right" delay={250}>
                    <FormattedHTMLMessage
                      id="offer.top-landing.hint-1"
                      defaultMessage="Work through the form of payment is allowed only with agreed landing pages."
                      tagName="p"
                    />
                  </Hint>
                ) : null}
              </FormGroup>
            </Fragment>
          ) : (
              <CustomControl
                className="custom-control-xs"
                type="radio"
                id={`${name}_${id}`}
                name={name}
                value={id}
                checked={isChecked}
                onChange={onLandingChange}
                disabled={!available}
              />
            )}
        </td>
        <td className="platform">
          <span id={`${name}_${id}_platform`} className="platform-icons">
            <SVG
              src={`${STATIC_PATH}/img/action-icons/desktop_icon.svg`}
              height="20"
              width="20"
              cacheRequests
              className={cn('landing-icon', {
                'is-active': !this.checkMobileString(title),
              })}
            />
            <SVG
              src={`${STATIC_PATH}/img/action-icons/mobile_icon.svg`}
              height="20"
              width="20"
              cacheRequests
              className={cn('landing-icon', {
                'is-active': adaptive > 0 || this.checkMobileString(title),
              })}
            />
          </span>

          <UncontrolledTooltip
            placement="right"
            target={`${name}_${id}_platform`}
            delay={{ show: 250, hide: 250 }}
          >
            {this.getResponsiveTooltip(adaptive, title)}
          </UncontrolledTooltip>
        </td>
        <td className="landings-item-title">
          <span className="landings-item-title-inner">
            <a href={url} title={url} target="_blank">
              {title}
            </a>

            {/* {isTop && ( */}
            {/* OFFERRUM-1781 attach badge to landing with max Cr */}
            {maxCrLandingId === id && (
              <span className="landings-item-top-badge">
                <FormattedMessage id="offer.top-link.badge" defaultMessage="Top" />
              </span>
            )}

            {url.search(/iframe_constructor/) > -1 && (
              <Fragment>
                <Icon
                  id={`iframe-constructor-gear-${id}`}
                  type="gear"
                  className="iframe-constructor-modal-open"
                  onClick={toggleIframeConstructorModal}
                />
                <UncontrolledTooltip
                  placement="right"
                  target={`iframe-constructor-gear-${id}`}
                  delay={{ show: 250, hide: 250 }}
                >
                  <FMessage id="flow.landings-table.iframe-constructor.hint" />
                </UncontrolledTooltip>
              </Fragment>
            )}
          </span>

        </td>
        <td>
          {/* OFFERRUM-2406 */}
          {!available ? (
            <Link
              className="btn btn-sm btn-primary"
              to={`/tickets/create?theme=RequestForAccessToTheSpOffer`}
            >
              <FormattedMessage id="offer.top-link.get-access-btn" defaultMessage="Top" />
            </Link>
          ): null}
        </td>
        <td className="text-right" ref={this.$containerRef}>
          {isMyOffer && (
            <Icon
              type="eye"
              className="preview-landing-link"
              id={`preview-landing-link-${id}`}
              onClick={this.togglePreviewPopover}
              title={getString(intl, 'offer.landings-table.preview', 'Preview')}
            >
              <PreviewPopover
                target={`preview-landing-link-${id}`}
                id={id}
                offerId={offerId}
                toggle={this.togglePreviewPopover}
                isOpen={previewPopoverIsOpen}
              />
            </Icon>
          )}
        </td>
        {showStreamCr && (
          <td className="values">
            {streamCr > 100 ? ">100" : streamCr}
            {inFlow && this.renderLinkToStatistics()}
          </td>
        )}
        <td className="values">
          <span>{totalCr > 100 ? ">100": totalCr}</span>
        </td>
        {is_cdn ? (
          <td>
            <Icon
              type="download"
              className="download-landing-link"
              id={`download-landing-link-${id}`}
              onClick={this.toggleDownload}
              title={getString(intl, 'offer.landings-table.download-archive', 'Download archive')}
            />
          </td>
        ) : null}
        {this.renderDownloadModal()}
      </tr>
    );
  }
}

FlowLandingsTableItem.propTypes = propTypes;
FlowLandingsTableItem.defaultProps = defaultProps;

export default FlowLandingsTableItem;
